/**
 * V3.1 — Multilang DealAlert Insight resolver.
 *
 * The backend generates the SAME market observation in DE/EN/HR
 * (`ai_insight_i18n`); the client picks by UI locale with a German
 * fallback (`ai_insight_one_liner` = DE, back-compat).
 */
import i18n from "../i18n";

export function resolveInsightText(card) {
  if (!card) return null;
  const lang = (i18n.language || "de").slice(0, 2).toLowerCase();
  const map = card.ai_insight_i18n;
  if (map && typeof map === "object") {
    return map[lang] || map.de || card.ai_insight_one_liner || null;
  }
  return card.ai_insight_one_liner || null;
}
